import { render } from "./StrategyList.vue?vue&type=template&id=5b12366a&scoped=true"
import script from "./StrategyList.vue?vue&type=script&lang=js"
export * from "./StrategyList.vue?vue&type=script&lang=js"

import "./StrategyList.vue?vue&type=style&index=0&id=5b12366a&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b12366a"]])

export default __exports__